import { sidebarName_en } from "./sidebarName";
import { about_en } from "./aboutInfo";

export default {
    sidebarName: sidebarName_en,
    about: about_en,
    chatArea: 'Chatting Room',
    send: 'Send',
    delete: 'Delete',
    audience: 'visitors',
    stopTalk: 'stop talking',
    endTalk: 'End Chatting',
    beginTalk: 'begin chatting',
    endForum: 'end',
    beginForum: 'begin',
    permissionDenied: 'no permission for microphone, camera. pls get permission.',
    ask: 'question',
    HTC: "MANUAL",
    forgotPwd: "Forget Password",
    agree: 'agree ',
    findPwd: "Reset Password",
    exit: 'Exit',
    talkEnded: 'talk ended ',
    forumEnded: 'forum ended',
    endTalkByAnchor: 'exhibitor has ended the talk',
    addToBlacklist: 'you are blacklisted',
    cancelAsk: 'questions-asking cancel ed',
    askReject: 'your questioning is rejected',
    askAgree: 'you can ask questions now',
    endAsk: 'questioning ended',
    addBlacklist: 'to be blacklisted',
    whiteboard: 'whiteboard',
    uploadFile: 'upload file',
    file: 'File',
    fileManage: 'View the File',
    appendixManage: 'Upload/Download',
    video: 'Video',
    inputPlease: 'Input your message..',
    title: 'title English',
    exhibition: "HOME",
    loginSuccess: "login in  successful",
    registerSuccess: "register successful ",
    payError: "pay error",
    search: "search",
    details: "Details",
    packUp: "pack up",
    userInfo: "Personal Center",
    login: "LOGIN",
    loadingLogin: "you are now loging in",
    register: " REGISTER",
    english: "CHINESE ",
    explain: "System operating instructions",
    exhibitionState: "Status Of The Fair",
    createSuccessful: "creation successful",
    seats: "seats",
    state0: "All",
    state1: "Pending ",
    state2: "On-going",
    state3: "Ended",

    exState: "IN PROMOTION",
    exState1: "MAKING AN APPOINTMENT",
    exState2: "ON-GOING",
    exState3: "ENDED",

    exhibitionSelect: "Please select ",
    exhibitionName: "EXHIBITION NAME",
    participation: "Participate",
    exhibitionVisit: "Visit",
    site: "booth",
    site1: "ticket",
    joinVenue: "Enter",
    exhibitionTime: "Exhibition Time",
    exhibitionIntroduce: "introduction ",
    clues: "Close To The Opening",
    day: "Day",
    loginPrompt: "Please enter email",
    password: "Password",
    client: "Client",
    peopleSeat: "seat/booth",
    accountLogin: "Account Login",
    ticketsLogin: "Ticket Login",
    banks: "Ticket No.",
    username: "User Name",
    phone: "Phone No.",
    ticketNumber: "Please enter the ticket number",
    inputName: "Please Enter Name",
    inputPhone: "Please input email",
    phoneLoginRules: "Not empty",
    inputCode: "Please Input code",
    setPwd: "Set Password",
    reqPwd: "Repeat Password",
    verificationCode: " Security Code",
    sendVerificationCode: "Get Code",
    toResend: "To resend",
    oneToOne: "One to one",
    originalPassword: 'Original Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    enterOriginalPassword: 'please enter original password',
    enterYourPassword: 'please ender your password',
    passwordAgain: 'pass word again',
    samePassword: 'same as the original password!',
    twoPassinconsistent: ' two passwords inconsistant!',
    to: "to",
    error: "No Data",
    playback: "Play Back",
    talkCompany: "talk company",
    forumCompany: "Record",
    copyTic: "copy",
    zhang: "sheet",
    buyTicketNumbers: "ticket numbers",
    watch: "watch",
    date: "date",
    forum: "Forum",
    userInfoRules: "Full information ",
    passwordRules: " Full password ",
    ticketRules: "Not empty",
    usernameRules: "Not empty",
    phoneRules: "phone not empty",
    codeRules: "Not empty",
    phoneCorrectlyRules: "Please enter the correct mobile phone number",
    userRules: "username not empty",
    userCorrectlyRules: "6-20 characters and Numbers",
    passwordCorrectlyRules: "The password should be 6-20 characters in letters, Numbers, or symbols (except Spaces)",
    emailRules: "Not empty",
    emailCorrectlyRules: "Please enter the correct email address",
    protocol: "I have read the ",
    nickName: "Name",
    talkBtn: "Chatting Now",
    companyName: "Company Name",
    regInputPhone: "Please Input Phone",
    home: "Country",
    userPost: " Position",
    email: "Email",
    contact: "Contact",
    companyNameRules: "Not empty ,max 100 characters",
    homeRules: "Not empty, max 100 characters",
    trueNameRules: "Not empty，max 5 characters",
    jobRules: "Not empty, max 60 characters",
    logout: "logout",
    marked: "Exit the current user?",
    hitDown: "Click the 'Download' button to download the highest version of Chrome",
    leaveDown: "Please go to Chrome and enter the studio",
    hold: "The stdudio function does not support this browser to run,",
    hint: "hint",
    aboutUs: "ABOUT US",
    blueBusiness: "BUSINESS",
    forwarderConference: "Forwarder conference",
    GlobalShippingSummit: "Global shipping summit",
    InternationalFreightFair: "International Freight FAIR",
    setToHomePage: "SET TO HOMEPAGE",
    shippingNetwork: "SHIPPING CHINA",
    allRightsReserved: "",
    internationalization: "The 9th China International Freight Forwarding Annual Conference and international freight exhibition",
    startTime: "Nov. 2nd-3rd, 2020",
    exhService: "Service Center",
    serveTel: "",
    sponsor: "Organizer, WIFFA ",
    localPlace: "Dalian International Conference Center, Hilton Dalian Fuli",
    scanQR: "Scan the code to learn more",
    local: "location",
    offlineEvent: " off line exhibition",
    business: "Cloud Exhibition",
    aboutExh: "About US",
    contactPeople: "Contact",
    advertisingAttract: "AD. Promotion",
    overseasInvestment: "For Overseas",
    FAE: "Technical Support",
    exhAttract: " For Domestic",
    telNumber: "Phone No.",
    exhTel: "Contact Us",
    platform: "Customer Services",
    card: "Business Cards",
    makeCard: "13000+ Contact NOW",
    extend: "",
    cloud: "Online Transactions Platform",
    vip: "WIFFA Network",
    directories: "98 cities in China",
    know: "1000+ members",
    customerPhone: "Tel. No.:",
    license: " License No.",
    internetRecord: "Internet Record No.",
    confirm: "Confirm",
    findInput: "Email",
    cancel: "Cancel",
    exitSuccess: "exit succeed",
    applet: "APPLET",
    pleaseEnterPwd: "Please Enter Your Password",
    pleaseAgainEnterPwd: "Please Enter Your Password Again",
    save: "Save",
    edit: "edit",
    enter: "Enter",
    buy: "Buy",
    //Personal center module
    personal: ' Information',
    exhibitionRecord: 'Record',
    ParticipationRecord: 'Record',
    myTicket: 'My ticket',
    subaccountManagement: 'Sub Account',
    studioManagement: 'Studio Booth',
    changePassword: 'Reset Password',
    createBBS: 'Create a BBS',
    create: "create",
    visitorTickets: 'Tickets',
    ticketsExhibition: 'Seats',
    oneTone: 'One to one',
    bbs: 'BBS',
    accountId: 'Account ID',
    mobilePhone: 'Cell Phone',
    overtime: "login timeout, please login again",
    getInMyTicket: 'you may check in your ticket ',
    getInMyTicket1: 'You can check it out from the guest seats',
    name: 'Name',
    hintContact: " Contact",
    classification: 'Business Type',
    accountError: "you can not invite others",
    //我的门票/观展门票 My ticket/visitors' tickets
    fairName: 'Name',
    fairTime: 'Time',
    price: 'Rate',
    buyTime: 'Pay Time',
    operation: 'Operation',
    state: "Status",
    playbackList: "play back list",
    //我的门票/参展门票 My tickets/exhibitors' tickets
    ticketsTypes: 'Type',
    role: 'role',
    attributable: 'Buyer',
    //直播间管理 Studio management
    bbsName: 'bbsName',
    studioFairName: 'Studio Booth Name/Fair Name',
    //观展记录 visitors record
    studioName: 'Studio Booth Name',
    broadcastType: 'Type',
    seeContact: "display contact",
    helpfulHints: " Tips!",
    notLogin: "Please login first or register",
    paymentMethod: "Please select.",
    buyWatchTickets: "buy watch-tickets to watch the war",
    buyExhibitionTickets: "Purchase of Tickets",
    onlineBuy: "Online Purchase",
    offlineBuy: "Offline Purchase",
    total: "Total",
    weChat: "WeChat",
    payTreasure: "Alipay",
    CNY: "CNY",
    rates: "ticket prices",
    see: "see",
    leave: "leave",
    buyTicketNumber: "",
    PCS: "pc",
    oneSeat: "1 seats",
    twoSeat: "2 seats",
    threeSeat: "3 seats",
    sum: "total",
    haveRead: "I have read",
    ticketAgreement: "ticket protocol",
    wxPay: "WeChat pay",
    payMoney: "",
    scan: "scan",
    scanPay: "Scan QR code",
    backPay: "Choose other payment methods",
    guest: "Guest",
    compere: "Host",
    time: "Time",
    notData: "Empty Data",
    watchReplay: "Watch The Replay",
    regSuccess: "Registered successfully",
    codeSendSuccess: "The Verification Code Was Sent To The Mailbox",
    codeError: "The mailbox has been registered, pls choose another one",
    ticText: " Invite into Live Streaming",
    editExh: "Set up",
    enterExh: "Enter",
    giving: "allocation",
    recycling: "recycle",
    buyOffInfo: "For offline purchase, please contact 04198258323 for details",
    liveClass: "room class",
    addChildAccount: "Add Sub Account",
    childAccount: 'choose a sub account',
    bbsTheme: "bbs theme",
    bbsTime: "bbs time",
    introduction: "Introduction",
    companyLogo: "Logo",
    enterUserId: "Please enter the added person's account ID",
    addSubaccount: "Add Sub Account",
    add: "add",
    exhSeat: "exhibition seat ",
    subaccountText: "Please enter the ID of the added person. If the added person is not registered, please let him/her register first。",
    areYouSuretoDelete: "confirm the deletion",
    icon: "email",
    lineWait: "line up",
    wait: "There is a negotiation in the studio, please wait in line",
    deal: " agreement",
    usageTitle: "The system supports PC brower only",
    chrome: "The latest version of chrome is recommended",
    down: "click to download chrome",
    appletCode: "applet QR code",
    weChatCode: "WeChat scan the QR code",
    room: "Studio Support",
    exhibitor: "Exhibitors using the latest version of chrome",
    visitor: "Visit the show using the latest version of the Chrome",
    addSub: "You do not have a sub-account, please add first.",
    goAdd: "go adding",
    giveSuccess: "give success",
    fileMaxSize: "file max size 1M",
    editSuccess: "edition success",
    delSuccess: "deletion success",
    addSuccess: "add success",
    youLine: "Are you in line",
    canEnter: "The studio is now accessible",
    into: "into",
    notEnter: "not Enter",
    browserTip: "Your current browser may not work properly. Please use the latest version of Chrome browser to enter.",
    gotIt: "got it",
    browserLink: "Download Chrome browser",
    UserHasLeft: "User has left",
    notMic: "No voice call without mic",
    notCamera: "No video call without camera",
    joinBlacklistTip: "Are you sure you want to join the blacklist?",
    someoneSpeaking: "Someone's speaking",
    networkDisconnect: "Network disconnect",
    download: "Download",
    roomNumberText: "{0} people have participated",

	peopleNumText: "{0} people have line up",

    appointments: "Checking",
    unfollow: "Cancel",
    makeSearch: "Search Name of Exhibition/Forum ",
    ahead: "Reservation",
    present: "engaged",
    people: "people",
    alreadyHave: "already have ",
    attend: "attend",
    homePage: "Home Page",
    alreadyHave: "Already have ",
    attend: "attendees",
    homePage: "Home Page",
    bookRecord: 'Reservation',

    Domestic1:'Liu Yu Zheng',
    Domestic2:'Ding Fang',
    Domestic3:'Lucy Bee',
    Promotion1:'Zhang Lin',
    Support1:'Cheng Pei Ju',

    //视频列表
    congratulationsTxt:'Congratulations',
    clickPlayInstructions:'Please click the play button to watch',

    //顶部导航添加表演标签
    perform:'SHOW'
}
